export const types = {
  'LOAD_SUBSCRIPTION': 'LOAD_SUBSCRIPTION'
};
